import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { RECOMMNDATION_SERVICE_METHOD } from "services/commonService";
import { OnboardingState } from "./Onboarding";

const SLICE = "OnboardingQueries";

const isOnboardingThunk = (action: any) => action.type.startsWith(`${SLICE}/`);

const initialState: OnboardingState = {
  loadingCount: 0,
  Onboarding: {},
  checkApiResponse: {},
  showOnboardingWizardFromLibrary: false
};

export const fetchOnboardingQueries = createAsyncThunk(`${SLICE}/fetchOnboardingQueries`, (data: any, thunkApi) => {
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.getWizards, {}, thunkApi, [data.wizardType], data?.payload);
});

export const fetchOnboardingQueriesCheck = createAsyncThunk(
  `${SLICE}/fetchOnboardingQueriesCheck`,
  (data: any, thunkApi) => apiRequest(RECOMMNDATION_SERVICE_METHOD.getWizardsCheck, {}, thunkApi, [], data)
);

export const updateOnboardingQueries = createAsyncThunk(`${SLICE}/updateOnboardingQueries`, (data: any, thunkApi) => {
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.putWizardsResponse, data.payload, thunkApi);
});

export const OnboardingSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...initialState,
        checkApiResponse: {
          createdDate: state.checkApiResponse.createdDate
        }
      };
    },
    resetOnBoardingDetails: () => {
      return initialState;
    },
    setShowOnboardingWizardFromLibrary: (state, action) => {
      state.showOnboardingWizardFromLibrary = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingQueriesCheck.fulfilled, (state, action) => {
        state.checkApiResponse = action.payload;
      })
      .addCase(fetchOnboardingQueries.fulfilled, (state, action) => {
        const { status, ...payload } = action.payload;
        state.Onboarding = payload;
      })
      .addCase(updateOnboardingQueries.fulfilled, (state, action) => {
        return {
          ...initialState,
          checkApiResponse: {
            createdDate: action.payload.createdDate
          }
        };
      })
      .addMatcher(
        (action) => isPending(action) && isOnboardingThunk(action),
        (state) => {
          state.loadingCount += 1;
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isOnboardingThunk(action),
        (state) => {
          state.loadingCount -= 1;
        }
      );
  }
});

export const { reset, setShowOnboardingWizardFromLibrary, resetOnBoardingDetails } = OnboardingSlice.actions;

export default OnboardingSlice.reducer;
